import { initRecommendClient } from '../../libs/algolia-service/algolia-recommend-init'

const initAlgoliaRecommendation = () => {
  if (!window.instanceAlgolia) {
    window.instanceAlgolia = initRecommendClient()
  }
}

initAlgoliaRecommendation()
